import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';

export const CustomFormControlLabel = styled(FormControlLabel)(() => ({
  '& span': {
    fontSize: 13
  }
}));
